
import { Type } from '@angular/core';

import { DunningActionDetailStoreAccountingEffects } from './effects.accounting';
import { DunningActionDetailStoreAttachmentsEffects } from './effects.attachments';
import { DunningActionDetailStoreCompletionEffects } from './effects.completion';
import { DunningActionDetailStoreDeletionEffects } from './effects.deletion';
import { DunningActionDetailStoreEditionEffects } from './effects.edition';
import { DunningActionDetailStoreGlobalEffects } from './effects.global';
import { DunningActionDetailStoreModalEffects } from './effects.modal';
import { DunningActionDetailStoreSendingCostsEffects } from './effects.postal-costs';
import { DunningActionDetailStorePreviewEffects } from './effects.preview';
import { DunningActionDetailStoreRealizedEffects } from './effects.realized';


export const effects: Type<any>[] = [
	DunningActionDetailStoreModalEffects,
	DunningActionDetailStoreGlobalEffects,
	DunningActionDetailStoreEditionEffects,
	DunningActionDetailStorePreviewEffects,
	DunningActionDetailStoreDeletionEffects,
	DunningActionDetailStoreRealizedEffects,
	DunningActionDetailStoreAccountingEffects,
	DunningActionDetailStoreCompletionEffects,
	DunningActionDetailStoreSendingCostsEffects,
	DunningActionDetailStoreAttachmentsEffects,
];
